import { render } from "./NewSeason.vue?vue&type=template&id=82cf3d5e&scoped=true"
import script from "./NewSeason.vue?vue&type=script&lang=js"
export * from "./NewSeason.vue?vue&type=script&lang=js"

import "./NewSeason.vue?vue&type=style&index=0&id=82cf3d5e&scoped=true&lang=css"
import "./NewSeason.vue?vue&type=style&index=1&id=82cf3d5e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82cf3d5e"]])

export default __exports__